<template>
  <el-dialog
    title="回款管理"
    :visible.sync="visible"
    v-dialogDrag
    width="500px"
    @keyup.enter.native="onSubmit()">
    <el-form ref="form"
             :model="form"
             :rules="formRules"
             label-width="80px">
      <el-form-item label="回款金额"
                    prop="received_amount">
        <el-input v-model="form.received_amount"
                  placeholder="请输入回款金额"></el-input>
      </el-form-item>
      <el-form-item label="回款日期"
                    prop="received_payment_time">
        <el-date-picker
          v-model="form.received_payment_time"
          value-format="yyyy-MM-dd"
          type="date"
          align="center"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="回款备注"
                    prop="desc">
        <el-input v-model="form.desc"
                  placeholder="请输入回款备注"></el-input>
      </el-form-item>

      <el-form-item label="附件" prop="attached_file">
        <el-upload
          class="upload-demo"
          action=""
          :auto-upload="false"
          :on-change="onChangeFile"
          :on-exceed="handleExceed"
          :limit="1"
          ref="upload"
          accept=".jpg, .jpeg, .png, .pdf, .eml, .zip"
        >
          <el-button size="small"
                     type="primary">点击上传
          </el-button>
          <div slot="tip"
               class="el-upload__tip">只能上传jpg/png/eml/pdf/zip文件
          </div>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary"
                   @click="onSubmit()">确 定</el-button>
      </span>
  </el-dialog>
</template>

<script>
import { formRules } from '../received-payment.rules.js'
import '../../../directive/dialog-drag'

export default {
  components: {},
  data () {
    return {
      formRules,
      title: '',
      visible: false,
      form: {
        receipt_apply_detail_id: null,
        received_amount: null,
        received_payment_time: null,
        desc: null,
        attached_file: null,
      },
      receipt_apply: {
        total: 0, // 此条开票申请的总申请金额
      },
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    checkParams () {
      if (this.form.received_amount * 1 === 0) {
        this.$message.error('回款时回款金额不能为 0！')
        return false
      }
      if (this.receipt_apply.total * this.form.received_amount < 0) {
        this.$message.error('回款时，回款金额与开票申请金额正负符号不同！')
        return false
      }
      return true
    },
    onSubmit () {
      if (!this.checkParams()) {
        return
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$confirm('此操作将回款, 是否继续?', '提示', {type: 'warning'}).then(() => {
            request.common('addReceivedPayment', this.form).then((res) => {
              this.$message.success('提交回款成功')
              this.visible = false
              this.clearValidate()
              this.$emit('refresh')
            })
          }).catch(() => {
            this.$message.info('已取消操作')
          })
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    openDialog (param) {
      this.form.receipt_apply_detail_id = param.id
      this.form.received_amount = param.unreceived_amount
      this.receipt_apply.total = param.total
      this.visible = true
    },
    clearValidate () {
      this.$nextTick(() => {
        this.$refs.form.resetFields()
        this.$refs.upload.clearFiles()
      })
    },
    onChangeFile (file) {
      let isLt2M = file.raw.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.clearFiles()
        return false
      }
      this.onUploadFile(file.raw)
    },
    onUploadFile (file) {
      let formData = new FormData()
      formData.append('file', file)
      return request.alert('uploadPaymentAttachedFile', formData).then(({data}) => {
        this.form.attached_file = data
      })
    },
    handleExceed (files, fileList) {
      this.$message.warning('只允许上传一个文件，多个文件请用zip打包')
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/ReceivedPaymentDialog.vue